export default __webpack_public_path__ + "static/media/Manuable_nacionalInternacional.4e6b968d.png";